import { styled } from "@mui/material";
import { ColorSAP, FONT_FAMILY } from "../../ontego-ui";

const Styled = {};

// ─── Outer wrapper ──────────────────────────────────────────────────────────

Styled.Container = styled("div")(() => ({
  height: "540px",
  position: "relative",
  overflow: "hidden",
  background: `linear-gradient(270deg, ${ColorSAP.primary[70]} 68.08%, ${ColorSAP.primary[90]} 112.75%)`,
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

Styled.Inner = styled("div")(() => ({
  height: "100%",
  width: "1200px",
  maxWidth: "1200px",
  position: "relative",
  display: "flex",
}));

// ─── Decorative radial gradient ─────────────────────────────────────────────

Styled.GradientOverlayYellow = styled("div")(() => ({
  position: "absolute",
  width: "100%",
  height: "100%",
  background: "radial-gradient(30% 60.08% at 65.07% 85%, var(--Color-Secondary-SE30, rgba(234, 230, 59, 0.70)) 0%, rgba(234, 230, 59, 0.00) 100%)",
  pointerEvents: "none",
}));

Styled.GradientOverlayGray = styled("div")(() => ({
  position: "absolute",
  width: "100%",
  height: "100%",
  background: "radial-gradient(20% 60.08% at 80.07% 90%, var(--Color-Primary-P00, rgba(253, 253, 255, 0.60)) 0%, rgba(253, 253, 255, 0.00) 100%)",
  pointerEvents: "none",
}));

// ─── Left content column ────────────────────────────────────────────────────

Styled.Content = styled("div")(() => ({
  marginTop: "168px",
  position: "relative",
  zIndex: 1,
  display: "flex",
  flexDirection: "column",
  gap: 0,
  maxWidth: "693px",
  flexShrink: 0,
}));

Styled.Title = styled("h2")(() => ({
  fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD,
  fontSize: 28,
  lineHeight: "36px",
  color: ColorSAP.neutral[0],
  margin: "0 0 12px 0",
}));

Styled.Description = styled("p")(() => ({
  fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR,
  fontSize: 16,
  lineHeight: "24px",
  color: ColorSAP.neutral[0],
  margin: "0 0 32px 0",
  opacity: 0.9,
}));

// ─── CTA Button (white pill) ────────────────────────────────────────────────

Styled.CTAButton = styled("button")(() => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 16,
  padding: "16px 24px",
  borderRadius: 100,
  border: "none",
  backgroundColor: ColorSAP.neutral[0],
  cursor: "pointer",
  transition: "background-color 0.2s ease, box-shadow 0.2s ease",
  "&:hover": {
    backgroundColor: ColorSAP.neutral[10],
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
  },
  "&:active": {
    backgroundColor: ColorSAP.neutral[15],
  },
}));

Styled.CTAButtonText = styled("span")(() => ({
  fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD,
  fontSize: 14,
  lineHeight: "17px",
  color: ColorSAP.neutral[100],
  whiteSpace: "nowrap",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
}));

Styled.CTAButtonArrow = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 24,
  height: 24,
  borderRadius: "50%",
  backgroundColor: ColorSAP.neutral[90],
  flexShrink: 0,
  "& svg": {
    width: "12px !important",
    height: "12px !important",
    color: ColorSAP.neutral[0],
  },
}));

// ─── Right asset area (checklist images) ────────────────────────────────────

Styled.AssetArea = styled("div")(() => ({
  position: "relative",
  zIndex: 1,
  width: 486,
  height: 316,
  flexShrink: 0,
}));

Styled.ChecklistCard = styled("div")(
  ({ rotation = 0, offsetX = 0, offsetY = 0, zIndex = 1 }) => ({
    position: "absolute",
    width: 300,
    borderRadius: 16,
    backgroundColor: ColorSAP.neutral[0],
    boxShadow: "0px 1px 24px 0px rgba(0, 0, 0, 0.22)",
    overflow: "hidden",
    transform: `rotate(${rotation}deg) translate(${offsetX}px, ${offsetY}px)`,
    zIndex,
  }),
);

Styled.ChecklistImage = styled("img")(() => ({
  width: "100%",
  height: "auto",
  display: "block",
}));

export default Styled;
